export const setAppViewportHeight = () => {
  if (typeof window === 'undefined') {
    return;
  }

  const viewportHeight = window.visualViewport?.height || window.innerHeight;
  const nextValue = `${viewportHeight}px`;
  const prevValue = document.documentElement.style.getPropertyValue('--app-dvh');
  if (prevValue === nextValue) {
    return;
  }

  document.documentElement.style.setProperty('--app-dvh', nextValue);
};

export const setupViewportHeightVar = () => {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  let rafId: number | null = null;
  const scheduleUpdate = () => {
    if (rafId !== null) {
      return;
    }

    rafId = window.requestAnimationFrame(() => {
      rafId = null;
      setAppViewportHeight();
    });
  };

  const onViewportChange = () => {
    scheduleUpdate();
  };

  const onVisibilityChange = () => {
    if (document.visibilityState !== 'visible') {
      return;
    }

    setAppViewportHeight();
  };

  setAppViewportHeight();
  const viewport = window.visualViewport;

  window.addEventListener('resize', onViewportChange);
  window.addEventListener('orientationchange', onViewportChange);
  viewport?.addEventListener('resize', onViewportChange);
  viewport?.addEventListener('scroll', onViewportChange, { passive: true });
  document.addEventListener('visibilitychange', onVisibilityChange);

  return () => {
    if (rafId !== null) {
      window.cancelAnimationFrame(rafId);
    }

    window.removeEventListener('resize', onViewportChange);
    window.removeEventListener('orientationchange', onViewportChange);
    viewport?.removeEventListener('resize', onViewportChange);
    viewport?.removeEventListener('scroll', onViewportChange);
    document.removeEventListener('visibilitychange', onVisibilityChange);
  };
};
